<template>
  <div class="cases">
    <div class="container">
      <div class="page-header">
        <h1 class="h1-title text-[#0E1F52] mb-4">客户成功案例</h1>
        <p>成功案例分享。覆盖能源电力、制造业、零售快消、金融、保险等行业，50+央企国企信赖之选</p>
      </div>

          <!-- ===== 01 客户行业分布 ===== -->
    <section class="section-padding bg-white">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 class="h2-title text-center text-[#0E1F52] mb-8">按行业浏览案例</h2>
            <div class="flex flex-wrap justify-center gap-4">
                <a href="file:///C:/Users/Lenovo/Desktop/2026-%E5%AE%98%E7%BD%91%E5%8D%87%E7%BA%A7/gushan-vue%20-%20%E5%89%AF%E6%9C%AC/%E5%AE%A2%E6%88%B7%E6%A1%88%E4%BE%8B%20%C2%B7%20%E5%8F%A4%E6%9D%89%E6%95%B0%E6%8D%AE%20%C2%B7%20%E8%83%BD%E6%BA%90%E7%94%B5%E5%8A%9B%20%C2%B7%20%E9%87%91%E8%9E%8D%20%C2%B7%20%E5%88%B6%E9%80%A0%20%C2%B7%20%E4%BF%9D%E9%99%A9%20%C2%B7%20%E9%9B%B6%E5%94%AE--A0.7.html#" class="px-6 py-3 bg-porcelain text-[#0E1F52] rounded-full border border-divider hover:bg-brand hover:text-white transition text-base font-medium">⚡ 能源电力</a>
                <a href="file:///C:/Users/Lenovo/Desktop/2026-%E5%AE%98%E7%BD%91%E5%8D%87%E7%BA%A7/gushan-vue%20-%20%E5%89%AF%E6%9C%AC/%E5%AE%A2%E6%88%B7%E6%A1%88%E4%BE%8B%20%C2%B7%20%E5%8F%A4%E6%9D%89%E6%95%B0%E6%8D%AE%20%C2%B7%20%E8%83%BD%E6%BA%90%E7%94%B5%E5%8A%9B%20%C2%B7%20%E9%87%91%E8%9E%8D%20%C2%B7%20%E5%88%B6%E9%80%A0%20%C2%B7%20%E4%BF%9D%E9%99%A9%20%C2%B7%20%E9%9B%B6%E5%94%AE--A0.7.html#" class="px-6 py-3 bg-porcelain text-[#0E1F52] rounded-full border border-divider hover:bg-brand hover:text-white transition text-base font-medium">🏭 制造业</a>
                <a href="file:///C:/Users/Lenovo/Desktop/2026-%E5%AE%98%E7%BD%91%E5%8D%87%E7%BA%A7/gushan-vue%20-%20%E5%89%AF%E6%9C%AC/%E5%AE%A2%E6%88%B7%E6%A1%88%E4%BE%8B%20%C2%B7%20%E5%8F%A4%E6%9D%89%E6%95%B0%E6%8D%AE%20%C2%B7%20%E8%83%BD%E6%BA%90%E7%94%B5%E5%8A%9B%20%C2%B7%20%E9%87%91%E8%9E%8D%20%C2%B7%20%E5%88%B6%E9%80%A0%20%C2%B7%20%E4%BF%9D%E9%99%A9%20%C2%B7%20%E9%9B%B6%E5%94%AE--A0.7.html#" class="px-6 py-3 bg-porcelain text-[#0E1F52] rounded-full border border-divider hover:bg-brand hover:text-white transition text-base font-medium">🛒 零售快消品</a>
                <a href="file:///C:/Users/Lenovo/Desktop/2026-%E5%AE%98%E7%BD%91%E5%8D%87%E7%BA%A7/gushan-vue%20-%20%E5%89%AF%E6%9C%AC/%E5%AE%A2%E6%88%B7%E6%A1%88%E4%BE%8B%20%C2%B7%20%E5%8F%A4%E6%9D%89%E6%95%B0%E6%8D%AE%20%C2%B7%20%E8%83%BD%E6%BA%90%E7%94%B5%E5%8A%9B%20%C2%B7%20%E9%87%91%E8%9E%8D%20%C2%B7%20%E5%88%B6%E9%80%A0%20%C2%B7%20%E4%BF%9D%E9%99%A9%20%C2%B7%20%E9%9B%B6%E5%94%AE--A0.7.html#" class="px-6 py-3 bg-porcelain text-[#0E1F52] rounded-full border border-divider hover:bg-brand hover:text-white transition text-base font-medium">🏦 金融行业</a>
                <a href="file:///C:/Users/Lenovo/Desktop/2026-%E5%AE%98%E7%BD%91%E5%8D%87%E7%BA%A7/gushan-vue%20-%20%E5%89%AF%E6%9C%AC/%E5%AE%A2%E6%88%B7%E6%A1%88%E4%BE%8B%20%C2%B7%20%E5%8F%A4%E6%9D%89%E6%95%B0%E6%8D%AE%20%C2%B7%20%E8%83%BD%E6%BA%90%E7%94%B5%E5%8A%9B%20%C2%B7%20%E9%87%91%E8%9E%8D%20%C2%B7%20%E5%88%B6%E9%80%A0%20%C2%B7%20%E4%BF%9D%E9%99%A9%20%C2%B7%20%E9%9B%B6%E5%94%AE--A0.7.html#" class="px-6 py-3 bg-porcelain text-[#0E1F52] rounded-full border border-divider hover:bg-brand hover:text-white transition text-base font-medium">🛡️ 保险行业</a>
            </div>
            <!-- 行业统计简表 -->
            <div class="mt-12 grid grid-cols-2 md:grid-cols-5 gap-4 text-center">
                <div><span class="text-3xl font-bold text-brand">15+</span><p class="text-sm text-[#5A5E66]">能源电力</p></div>
                <div><span class="text-3xl font-bold text-brand">12+</span><p class="text-sm text-[#5A5E66]">制造业</p></div>
                <div><span class="text-3xl font-bold text-brand">8+</span><p class="text-sm text-[#5A5E66]">零售快消</p></div>
                <div><span class="text-3xl font-bold text-brand">20+</span><p class="text-sm text-[#5A5E66]">金融行业</p></div>
                <div><span class="text-3xl font-bold text-brand">10+</span><p class="text-sm text-[#5A5E66]">保险行业</p></div>
            </div>
        </div>
    </section>


      <section class="cases-grid">
        <div class="case-card" v-for="caseItem in cases" :key="caseItem.id" @click="goToDetail(caseItem.id)">
          <div class="case-image">
            <div class="case-placeholder">{{ caseItem.company }}</div>
          </div>
          <div class="case-content">
            <h3>{{ caseItem.title }}</h3>
            <p class="company">{{ caseItem.company }}</p>
            <p class="description">{{ caseItem.description }}</p>
            <div class="case-tags">
              <span v-for="tag in caseItem.tags" :key="tag" class="tag">{{ tag }}</span>
            </div>
              <div class="mt-4 flex items-center justify-between">
                  <span class="text-[#1F3F8F]">阅读案例</span>
                  <span class="text-xs text-[#5A5E66]">2026-02</span>
              </div>
          </div>
        </div>
      </section>

      <!-- 查看更多按钮 -->
      <div class="text-center mt-12">
          <router-link to="/training/all-courses" class="inline-block px-8 py-3 border border-brand text-brand rounded-md hover:bg-porcelain transition">查看更多案例</router-link>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'Cases',
  data() {
    return {
      cases: [
        {
          id: 1,
          title: '某大型制造企业数字化转型项目',
          company: 'ABC制造集团',
          description: '帮助企业实现生产流程数字化，提升30%生产效率',
          tags: ['数字化转型', '制造业', '流程优化']
        },
        {
          id: 2,
          title: '金融科技公司战略咨询',
          company: 'XYZ金融科技',
          description: '协助企业制定三年发展战略，成功拓展新业务领域',
          tags: ['战略咨询', '金融', '业务拓展']
        },
        {
          id: 3,
          title: '零售连锁企业供应链优化',
          company: 'DEF零售集团',
          description: '优化供应链管理体系，降低20%运营成本',
          tags: ['供应链', '零售', '成本优化']
        },
        {
          id: 4,
          title: '互联网公司组织变革',
          company: 'GHI科技公司',
          description: '推动组织架构调整，提升团队协作效率',
          tags: ['组织变革', '互联网', '团队建设']
        },
        {
          id: 5,
          title: '医疗机构信息化建设',
          company: 'JKL医疗集团',
          description: '建立完善的医疗信息管理系统，提升服务质量',
          tags: ['信息化', '医疗', '系统建设']
        },
        {
          id: 6,
          title: '教育集团数字化平台',
          company: 'MNO教育集团',
          description: '打造在线教育平台，扩展服务范围和影响力',
          tags: ['教育', '平台建设', '在线服务']
        }
      ]
    }
  },
  methods: {
    goToDetail(id) {
      this.$router.push(`/case/${id}`)
    }
  }
}
</script>

<style scoped>

.section-padding { padding-top: 25px; padding-bottom: 50px; }
.h1-title { font-size: 42px; line-height: 1.2; font-weight: 700; }
.h2-title { font-size: 28px; line-height: 1.3; font-weight: 700; }
.subtitle { font-size: 18px; line-height: 1.5; }
.body-text { font-size: 16px; line-height: 1.6; }
.dropdown-glass {
    background: rgba(255, 255, 255, 0.98);
    backdrop-filter: blur(8px);
    border: 1px solid var(--divider);
    border-radius: 0.75rem;
    box-shadow: 0 12px 30px -8px rgba(0,0,0,0.05);
}

.cases {
  min-height: 600px;
  padding: 60px 0;
}

.page-header {
  text-align: center;
  margin-bottom: 60px;
}

.page-header h1 {
  font-size: 42px;
  color: var(--text-primary);
  margin-bottom: 16px;
}

.page-header p {
  font-size: 18px;
  color: var(--text-secondary);
}

.cases-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.case-card {
  background-color: var(--white);
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s;
  cursor: pointer;
}

.case-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

.case-image {
  height: 180px;
  background: linear-gradient(135deg, var(--brand-blue), var(--deep-indigo));
  display: flex;
  align-items: center;
  justify-content: center;
}

.case-placeholder {
  color: var(--white);
  font-size: 24px;
  font-weight: bold;
}

.case-content {
  padding: 24px;
}

.case-content h3 {
  font-size: 18px;
  color: var(--text-primary);
  margin-bottom: 8px;
  line-height: 1.4;
}

.company {
  color: var(--brand-blue);
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 12px;
}

.description {
  color: var(--text-secondary);
  font-size: 16px;
  line-height: 1.8;
  margin-bottom: 16px;
}

.case-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.tag {
  background-color: var(--porcelain-blue);
  color: var(--brand-blue);
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
}
</style>
